module.exports = __webpack_public_path__ + "img/banner1.945b92c6.png";